import { FC, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useKeyboardShortcut } from 'src/hooks';
import theme from 'src/utils/theme';
import { DropdownMenu, DropdownSectionProps } from '../DropdownMenu';
import Icon from '../Icon';
import { Popout, PopoutProps } from '../Popout';
import * as S from './styles';

const msgs = defineMessages({
  seeMore: { id: 'card_statistics_link_see_more' },
});

interface Props {
  dropdownSections: DropdownSectionProps[];
  positionX: PopoutProps['positionX'];
  positionY?: PopoutProps['positionY'];
  className?: string;
}

export const EllipsisPopout: FC<Props> = ({
  dropdownSections,
  positionX,
  positionY,
  className,
}) => {
  const intl = useIntl();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  useKeyboardShortcut('esc', () => setIsDropdownOpen(false));

  return (
    <Popout.ParentContainer>
      <S.Button
        aria-label={intl.formatMessage(msgs.seeMore)}
        onClick={() => setIsDropdownOpen(true)}
        className={className}
      >
        <Icon name="more" />
      </S.Button>

      <Popout
        noBackdrop
        show={isDropdownOpen}
        positionX={positionX}
        positionY={positionY}
        onClickBackdrop={() => setIsDropdownOpen(false)}
      >
        <DropdownMenu
          borderWidth={theme.bo.thinWidth}
          dropdownSections={dropdownSections}
          onClickItem={() => setIsDropdownOpen(false)}
        />
      </Popout>
    </Popout.ParentContainer>
  );
};
